
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "branch",
  "title": "Branch Metrics",
  "sidebar_label": "Branch Metrics"
};
const slug = 'branch';
const tableOfContents = [{
  "title": "Video: Configuring Branch",
  "slug": "video-configuring-branch",
  "children": []
}, {
  "title": "Requirements",
  "slug": "requirements",
  "children": []
}, {
  "title": "Pricing",
  "slug": "pricing",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <h1>{`Integrating Branch Metrics`}</h1>
    <p>{`Branch Metrics provides solutions that unify user measurement across different devices and channels.`}</p>
    <p>{`Features like invite your features, Marketing tracking links generations, Deep-links content views, etc in our app done using Branch technologies. Hence, it is mandatory to have this extension activated if you want to use those features. `}</p>
    <_Heading level={2} id={"video-configuring-branch"} nextElement={{
      "type": "paragraph"
    }}>Video: Configuring Branch</_Heading>
    <p>{`See how to configure stripe for your marketplace. `}</p>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/TAaEknMCemQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <_Heading level={2} id={"requirements"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Requirements</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Signup for a free account here, `}<a parentName="li" {...{
          "href": "https://branch.io"
        }}>{`Branch Signup`}</a>{`.`}</li>
      <li parentName="ol">{`Navigate to `}{`[profile section]`}{` (`}<a parentName="li" {...{
          "href": "https://dashboard.branch.io/account-settings/profile"
        }}>{`https://dashboard.branch.io/account-settings/profile`}</a>{`). `}</li>
      <li parentName="ol">{`Find the APP ID.`}</li>
      <li parentName="ol">{`Update the APP ID inside the SuperAdmin panel settings page > Branch App ID.`}</li>
    </ol>
    <_Heading level={2} id={"pricing"} nextElement={{
      "type": "paragraph"
    }}>Pricing</_Heading>
    <p>{`Branch Metrics has certain feature free and some advanced functions with paid plan. You need the free package for the above features we have mentioned (for up to 10K MAU).`}</p>
    <p>{`Read more `}<a parentName="p" {...{
        "href": "https://branch.io/pricing"
      }}>{`here`}</a>{` on their pricing structure.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
